import { render, staticRenderFns } from "./RecordSell.vue?vue&type=template&id=494ed7e0&scoped=true&"
import script from "./RecordSell.vue?vue&type=script&lang=js&"
export * from "./RecordSell.vue?vue&type=script&lang=js&"
import style0 from "./RecordSell.vue?vue&type=style&index=0&id=494ed7e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494ed7e0",
  null
  
)

export default component.exports